import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { TaskScheduleVariableContentComponent } from '../content/content.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TaskScheduleVariableService } from '../../service/variable.service';

@Component({
	selector: 'app-task-schedule-variable-detail',
	templateUrl: './detail.component.html',
	styleUrls: ['./detail.component.scss']
})
export class TaskScheduleVariableDetailComponent implements OnInit, OnDestroy {

	id: string;
	variable: any;
	routeSubscription: Subscription;
	
	@ViewChild('content', {static: false}) content: TaskScheduleVariableContentComponent;
	
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private variableService: TaskScheduleVariableService,
		private translateService: TranslateService
	) {
		this.routeSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.id = this.route.snapshot.paramMap.get('id');

				if (this.id) {
					this.variableService.get(this.id).subscribe((variable: any) => {
						this.variable = variable;
					});
				} else {
					this.variable = {};
				}
			}
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		this.routeSubscription.unsubscribe();
	}

	goBack() {
		this.router.navigate([ '/main', { outlets: { content: 'setting/task/schedule/variable/list' }}]);
	}

	doSave() {
		this.translateService.get([
			'common.invalid.alert',
			'setting.task.schedule.variable.detail.confirm.save',
			'setting.task.schedule.variable.detail.alert.saved',
			'setting.task.schedule.variable.detail.alert.save-failed',
			'setting.task.schedule.variable.detail.alert.invalid-length-body',
			'setting.task.schedule.variable.detail.alert.invalid-json-body',
			'setting.task.schedule.variable.detail.alert.invalid-length-columns',
			'setting.task.schedule.variable.detail.alert.invalid-json-columns'
		]).subscribe((messages: any) => {
			if (!this.content.valid) {
				alert(messages['common.invalid.alert']);
				this.content.validate();
			} else if (this.content.invalidBody === 'body-length-invalid') {
				alert(messages['setting.task.schedule.variable.detail.alert.too-long-api-body']);
				return;
			} else if (this.content.invalidBody === 'body-json-invalid') {
				alert(messages['setting.task.schedule.variable.detail.alert.invalid-json-body']);
				return;
			} else if (this.content.invalidColumns === 'columns-length-invalid') {
				alert(messages['setting.task.schedule.variable.detail.alert.too-long-api-columns']);
				return;
			} else if (this.content.invalidColumns === 'columns-json-invalid') {
				alert(messages['setting.task.schedule.variable.detail.alert.invalid-json-columns']);
				return;
			} else {
				if (confirm(messages['setting.task.schedule.variable.detail.confirm.save'])) {
					if (this.variable.variableCustomType) {
						this.variable.variableType = this.variable.variableCustomType;
					}
					this.variableService.save(this.variable, this.id).subscribe((result: any) => {
						alert(messages['setting.task.schedule.variable.detail.alert.saved']);
						this.router.navigate([ '/main', { outlets: { content: 'setting/task/schedule/variable/detail/' + result.id + '/' }}]);
					}, () => {
						alert(messages['setting.task.schedule.variable.detail.alert.save-failed']);
					})
				}					
			}
		});
	}

	doDelete() {
		this.translateService.get([
			'setting.task.schedule.variable.detail.confirm.delete',
			'setting.task.schedule.variable.detail.alert.deleted',
			'setting.task.schedule.variable.detail.alert.invalid-by-associated-variable',
			'setting.task.schedule.variable.detail.alert.delete-failed'
		]).subscribe((messages: any) => {
			this.variableService.checkValidityForDelete(this.id).subscribe(() => {
				if (confirm(messages['setting.task.schedule.variable.detail.confirm.delete'])) {
					this.variableService.delete(this.id).subscribe(() => {
						alert(messages['setting.task.schedule.variable.detail.alert.deleted']);
						this.router.navigate([ '/main', { outlets: { content: 'setting/task/schedule/variable/list' }}]);
					}, () => {
						alert(messages['setting.task.schedule.variable.detail.alert.delete-failed']);
					})
				}
			}, () => {
				alert(messages['setting.task.schedule.variable.detail.alert.invalid-by-associated-variable'])
			});
		});
	}
}
